module.exports = __webpack_public_path__ + "static/assets/8701a9f930c844208c5548c3972cd78b.svg";